<template>
    <span class="badge-copy border-radius d-inline-flex flex-align-center"
          @mouseenter="showOptions = true"
          @mouseleave="showOptions = false"
          @mousedown.stop="dummy">
        <span class="d-inline-block text-ellipsis" style="max-width: 50vw">
            <a :href="link" v-if="link" :target="alwaysInNewTab ? '_blank' : null">
                {{text}}
            </a>
            <span @mouseenter="showOptions = true" v-else>
                {{text}}
            </span>
        </span>
        <span class="cursor-pointer ml-1"
              :style="{ visibility: showOptions ? 'visible' : 'hidden' }">
            <slot></slot>
        </span>
        <span v-if="allowCopy" class="cursor-pointer ml-1" @click.stop="copy"
              :style="{ visibility: showOptions ? 'visible' : 'hidden' }" v-tooltip="'Copiar'">
            <span class="fas fa-copy"/>
        </span>
        <a :href="link"
           v-if="link && !alwaysInNewTab"
           :style="{ visibility: showOptions ? 'visible' : 'hidden' }"
           target="_blank"
           class="cursor-pointer ml-1"
           v-tooltip="'Abrir em nova aba'">
            <span class="fas fa-share-square"/>
        </a>
    </span>
</template>

<script>
    import {copyToClipboard} from "../../../common/common";

    export default {
        name: "CopyButton",

        props: {
            text: {
                type: String | Number,
                required: true
            },
            allowCopy: {
                type: Boolean,
                default: true
            },
            textToCopy: String | Number,
            link: String,
            alwaysInNewTab: Boolean,
        },

        data() {
            return {
                showOptions: false,
            }
        },

        methods: {
            copy() {
                copyToClipboard(this.textToCopy || this.text);
            },

            dummy() {
            }
        }
    }
</script>